import createLogger from '~/src/Lib/Logging'

export const createNamespacedLogger = name => createLogger(name.startsWith('RD/') ? name : `RD/${name}`)
